import { APIPrefix } from '../utils/functions';
import { callback_url } from '../utils/auth';
import { GlobalState } from '../app/global-slice';

export async function userLogin(args: {
  authCode?: string | null;
  redirectUri?: string;
}): Promise<{ ok: boolean; nextAppState?: Partial<GlobalState> }> {
  //
  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  const SET_UNDEFINED: any = null;
  const authCode = args.authCode ?? null;
  const redirectUri = callback_url();
  if (!authCode) return { ok: false };

  //setLoadingToken(true);

  let nextAppState: Partial<GlobalState> = {
    loggedIn: false,
    sessionValid: false,
    username: SET_UNDEFINED,
    preferredUsername: SET_UNDEFINED,
    gatewayBackendToken: SET_UNDEFINED,
    siteCapabilitiesTokenObtained: false,
    dataManagementTokenObtained: false,
    project: undefined,
    site: undefined,
  };

  let showError = false;

  try {
    const res = await fetch(
      `${APIPrefix()}/v1/login?code=${encodeURIComponent(authCode)}&redirect_uri=${encodeURIComponent(redirectUri)}`,
      {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      },
    );

    if (!res.ok) {
      console.error('userLogin: Response not OK, status =', res.status);
      const errorText = await res.text();
      console.error('userLogin: Error response body =', errorText);
      showError = true;
    } else {
      const json = await res.json();

      if (json.logged_in === true) {
        nextAppState = {
          ...nextAppState,
          loggedIn: true,
          sessionValid: true,
          loggedInRefreshTrigger: Date.now(),
          username: json.name || SET_UNDEFINED,
          preferredUsername: json.preferred_username,
          siteCapabilitiesTokenObtained:
            json.token_info?.site_capabilities_api?.obtained ?? false,
          dataManagementTokenObtained:
            json.token_info?.data_management_api?.obtained ?? false,
        };

        return { ok: true, nextAppState };
      }
      console.error('userLogin: logged_in is not true in response');
      showError = true;
    }
  } catch (e) {
    console.error('userLogin error', e);
    showError = true;
  } finally {
    //setLoadingToken(false);
  }

  if (showError) {
    console.error('userLogin: Login failed');
    //toast(<ErrorToast text="Error logging in. Check logs for details." path="/logs" />);
  }
  return { ok: false };
}
